import { authPut } from "@api";

interface EmailSettingsBody {
  email: string;
  subscribe: boolean;
  contact_about_experiments: boolean;
  used_cli_login: boolean;
}

export const putUserEmail = (
  email: string,
  subscribe: boolean,
  contact_about_experiments: boolean,
  used_cli_login: boolean
) => {
  return authPut<EmailSettingsBody, string>("/api/user/email", {
    email,
    subscribe,
    contact_about_experiments,
    used_cli_login,
  });
};
